import { c as _c } from "react/compiler-runtime";
import PaymentField from '@/components/fields/PaymentField';
import useCartFormCreditCard from '@/contexts/cartContext/hooks/useCartFormCreditCard';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import usePageFormErrors from '@/contexts/pageContext/hooks/usePageFormErrors';
import { FFormIdEnum } from '@/types/form';
import { Info } from '@winelidays/wld-tsx-2/elements';
const PaymentForm = () => {
    const $ = _c(22);
    const translate = useTranslate();
    const { creditCardError, setIsCreditCardInError } = useCartFormCreditCard();
    const { showFormErrors, setShowFormErrors } = usePageFormErrors(FFormIdEnum.CART_VALIDATION);
    let t0;
    if ($[0] !== translate) {
        t0 = translate("validation_page.payment.title");
        $[0] = translate;
        $[1] = t0;
    }
    else {
        t0 = $[1];
    }
    const title = t0;
    let t1;
    if ($[2] !== translate) {
        t1 = translate("validation_page.payment.nav_label");
        $[2] = translate;
        $[3] = t1;
    }
    else {
        t1 = $[3];
    }
    const navLabel = t1;
    let t2;
    if ($[4] !== translate) {
        t2 = translate("validation_page.payment.info");
        $[4] = translate;
        $[5] = t2;
    }
    else {
        t2 = $[5];
    }
    const info = t2;
    let t3;
    if ($[6] !== setShowFormErrors) {
        t3 = () => {
            setShowFormErrors(false);
        };
        $[6] = setShowFormErrors;
        $[7] = t3;
    }
    else {
        t3 = $[7];
    }
    const handleChange = t3;
    let t4;
    if ($[8] !== navLabel || $[9] !== title) {
        t4 = <h2 className="text-2xl font-bold mb-4" id="payment" data-nav-label={navLabel}>
      {title}
    </h2>;
        $[8] = navLabel;
        $[9] = title;
        $[10] = t4;
    }
    else {
        t4 = $[10];
    }
    let t5;
    if ($[11] !== info) {
        t5 = <Info className="mb-6">{info}</Info>;
        $[11] = info;
        $[12] = t5;
    }
    else {
        t5 = $[12];
    }
    let t6;
    if ($[13] !== creditCardError || $[14] !== handleChange || $[15] !== setIsCreditCardInError || $[16] !== showFormErrors) {
        t6 = <PaymentField formId={FFormIdEnum.CART_VALIDATION} error={creditCardError} setErrorStatus={setIsCreditCardInError} showError={showFormErrors} onChange={handleChange} hideLabel={true}/>;
        $[13] = creditCardError;
        $[14] = handleChange;
        $[15] = setIsCreditCardInError;
        $[16] = showFormErrors;
        $[17] = t6;
    }
    else {
        t6 = $[17];
    }
    let t7;
    if ($[18] !== t4 || $[19] !== t5 || $[20] !== t6) {
        t7 = <div>{t4}{t5}{t6}
    </div>;
        $[18] = t4;
        $[19] = t5;
        $[20] = t6;
        $[21] = t7;
    }
    else {
        t7 = $[21];
    }
    return t7;
};
export default PaymentForm;
